import { render } from "./Index.vue?vue&type=template&id=4b238cb4"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4b238cb4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Team/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b238cb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b238cb4', __exports__)) {
    api.reload('4b238cb4', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4b238cb4", () => {
    api.rerender('4b238cb4', render)
  })

}


export default __exports__